export default __webpack_public_path__ + "static/haiku-space-0d89068f8f5ee0f3729443eee67c88ea.svg";